module.exports = __webpack_public_path__ + "img/Me╠üdico-Internacional.774acb79.png";